import React from 'react';
import DashBoardGestao from './components/DashBoardGestao';
import DashBoardDestino from './components/DashBoardDestino';
import DashBoardTransportador from './components/DashBoardTransportador';
import DashBoardGerador from './components/DashBoardGerador';
import DashBoardFiscal from './components/DashBoardFiscal';
import { getSessionCookie } from '../../helpers/cookies';
export default function DashBoard() {
    function getDashBoard() {
        const usuario = getSessionCookie();
        switch (usuario.acesso.sigla) {
            case "GS": {
                return <DashBoardGestao />
            }
            case "DS": {
                return <DashBoardDestino />
            }
            case "TR": {
                return <DashBoardTransportador />
            }
            case "GG": {
                return <DashBoardGerador />
            }
            case "FS": {
                return <DashBoardFiscal />
            }
        }
    }
    return (
        <>
            {getDashBoard()}
        </>
    );
}